import { useEffect } from "react";
import { isLiveChatEnabled } from "./liveChatConfig";
import { initializeLiveChat } from "./liveChatClient";

// Preserve the SDK and conversation. The selector also catches late SDK nodes.
const gameChatVisibility = `
  body.crypto-game-player-active #chat-widget-container,
  body.crypto-game-player-active #chat-widget-minimized,
  body.crypto-game-player-active #chat-widget {
    display: none !important;
    visibility: hidden !important;
    pointer-events: none !important;
  }
`;

const LiveChat = ({
  environment = process.env,
  windowObject = typeof window === "undefined" ? undefined : window,
  documentObject = typeof document === "undefined" ? undefined : document,
}) => {
  const enabled = isLiveChatEnabled(environment);

  useEffect(() => {
    if (!enabled || !windowObject || !documentObject) return undefined;
    return initializeLiveChat({ windowObject, documentObject });
  }, [documentObject, enabled, windowObject]);

  return enabled ? <style data-game-chat-visibility>{gameChatVisibility}</style> : null;
};

export default LiveChat;
